import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cb3414c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid justify-items-center mt-10 pb-10 w-full" }
const _hoisted_2 = { class: "mb-4 md:w-4/12 sm:w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://res.cloudinary.com/djrfhrpvq/image/upload/v1639509164/vibes/vibes-logo-animated_u7nrye.svg",
  alt: "Vibes Logo",
  class: "logo"
}, null, -1))
const _hoisted_4 = { class: "nav w-full grid justify-items-center mt-10 desktop nav-gradient" }
const _hoisted_5 = { class: "grid grid-flow-col lg:gap-8 md:gap-4 justify-items-center mb-10 mt-10" }
const _hoisted_6 = { class: "nav w-full grid justify-items-center mt-10 mobile nav-gradient" }
const _hoisted_7 = { class: "grid justify-items-center mb-10 mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavButton = _resolveComponent("NavButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: _ctx.home }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (i) => {
          return (_openBlock(), _createBlock(_component_NavButton, {
            key: i.name,
            title: i.name,
            url: i.url,
            class: _normalizeClass({ active: _ctx.path === i.url })
          }, null, 8, ["title", "url", "class"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (i) => {
          return (_openBlock(), _createBlock(_component_NavButton, {
            key: i.name,
            title: i.name,
            url: i.url,
            class: _normalizeClass({ active: _ctx.path === i.url })
          }, null, 8, ["title", "url", "class"]))
        }), 128))
      ])
    ])
  ]))
}